export default __webpack_public_path__ + "static/media/fw-olivia-er-Yellow Gold.deda8980.mp4";